// extracted by mini-css-extract-plugin
module.exports = {"dropZone":"navigation_dropZone_1B4","hover":"navigation_hover_3tp","disabled":"navigation_disabled_4XM"};